import { render, staticRenderFns } from "./DictionaryMangement.vue?vue&type=template&id=16e44080&scoped=true&"
import script from "./DictionaryMangement.vue?vue&type=script&lang=js&"
export * from "./DictionaryMangement.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryMangement.vue?vue&type=style&index=0&id=16e44080&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e44080",
  null
  
)

export default component.exports